import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationComponent } from '@shared/layout/navigation/navigation.component';
import { IconModule } from '@mastechnicaegroup/carelinelive-ui';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrl: './shell.component.scss',
    standalone: true,
    imports: [
        RouterOutlet,
        NavigationComponent,
        IconModule,
    ]
})
export class ShellComponent {

}
